<template>
  <component :is="tag" :class="cardClasses" data-testid="bs-card">
    <slot name="header">
      <component
        v-if="header || $scopedSlots.header"
        :is="headerTag"
        :class="headerClasses"
      >
        <slot name="header-content">
          {{ header }}
        </slot>
      </component>
    </slot>
    <div v-if="!noBody" :class="bodyClasses">
      <slot />
    </div>
    <slot v-else />
    <slot name="footer">
      <component
        v-if="footer || $scopedSlots.footer"
        :is="footerTag"
        :class="footerClasses"
      >
        <slot name="footer-content">
          {{ footer }}
        </slot>
      </component>
    </slot>
  </component>
</template>

<script>
export default {
  name: 'b-card',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    noBody: {
      type: Boolean,
      default: false,
    },
    bgVariant: {
      type: String,
      default: null,
    },
    textVariant: {
      type: String,
      default: null,
    },
    borderVariant: {
      type: String,
      default: null,
    },
    header: {
      type: String,
      default: null,
    },
    headerTag: {
      type: String,
      default: 'div',
    },
    headerBgVariant: {
      type: String,
      default: null,
    },
    headerTextVariant: {
      type: String,
      default: null,
    },
    headerClass: {
      type: [String, Object, Array],
      default: null,
    },
    footer: {
      type: String,
      default: null,
    },
    footerTag: {
      type: String,
      default: 'div',
    },
    footerBgVariant: {
      type: String,
      default: null,
    },
    footerTextVariant: {
      type: String,
      default: null,
    },
    footerClass: {
      type: [String, Object, Array],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    titleTag: {
      type: String,
      default: 'h4',
    },
    subTitle: {
      type: String,
      default: null,
    },
    subTitleTag: {
      type: String,
      default: 'h6',
    },
  },
  computed: {
    cardClasses() {
      const classes = ['card'];
      if (this.bgVariant) classes.push(`bg-${this.bgVariant}`);
      if (this.textVariant) classes.push(`text-${this.textVariant}`);
      if (this.borderVariant) classes.push(`border-${this.borderVariant}`);
      return classes;
    },
    bodyClasses() {
      const classes = ['card-body'];
      return classes;
    },
    headerClasses() {
      const classes = ['card-header', this.headerClass];
      if (this.headerBgVariant) classes.push(`bg-${this.headerBgVariant}`);
      if (this.headerTextVariant) classes.push(`text-${this.headerTextVariant}`);
      return classes;
    },
    footerClasses() {
      const classes = ['card-footer', this.footerClass];
      if (this.footerBgVariant) classes.push(`bg-${this.footerBgVariant}`);
      if (this.footerTextVariant) classes.push(`text-${this.footerTextVariant}`);
      return classes;
    },
  },
};
</script>